/**
 * Toast component with Headless UI Transition for slide-up animation
 */

import { Transition } from "@headlessui/react";

interface ToastProps {
  readonly show: boolean;
  readonly message: string;
  readonly className?: string;
}

export function Toast({ show, message, className = "" }: ToastProps) {
  return (
    <Transition
      show={show}
      enter="transition duration-300 ease-out"
      enterFrom="translate-y-4 opacity-0"
      enterTo="translate-y-0 opacity-100"
      leave="transition duration-200 ease-in"
      leaveFrom="translate-y-0 opacity-100"
      leaveTo="translate-y-4 opacity-0"
    >
      <div
        className={`fixed bottom-4 left-1/2 z-50 -translate-x-1/2 rounded-md bg-neutral-900 px-4 py-2 text-sm text-white shadow-lg ${className}`}
      >
        {message}
      </div>
    </Transition>
  );
}
